var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41667 18.3333C3.80584 18.3333 2.5 17.0274 2.5 15.4166C2.5 14.0203 3.48117 12.8532 4.79167 12.567V9.9999C4.79167 9.6547 5.07149 9.3749 5.41667 9.3749H9.375V7.4328C8.06451 7.1467 7.08333 5.9796 7.08333 4.5833C7.08333 2.9724 8.38917 1.6666 10 1.6666C11.6108 1.6666 12.9167 2.9724 12.9167 4.5833C12.9167 5.9796 11.9355 7.1467 10.625 7.4328V9.3749H14.5833C14.9285 9.3749 15.2083 9.6547 15.2083 9.9999V12.567C16.5188 12.8532 17.5 14.0203 17.5 15.4166C17.5 17.0274 16.1942 18.3333 14.5833 18.3333C12.9725 18.3333 11.6667 17.0274 11.6667 15.4166C11.6667 14.0203 12.6478 12.8532 13.9583 12.567V10.6249H6.04167V12.567C7.35216 12.8532 8.33333 14.0203 8.33333 15.4166C8.33333 17.0274 7.0275 18.3333 5.41667 18.3333Z",
    fill: "#0F55DC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpIcon);
export default __webpack_public_path__ + "static/media/cp-icon.33076c5f41539401d366f9cd7ea3162c.svg";
export { ForwardRef as ReactComponent };